<!-- Barra de selección múltiple -->
@if (selected.size > 0) {
  <div class="flex items-center gap-4 px-4 py-3 mb-3 bg-brand-50 dark:bg-brand-500/10 border border-brand-200 dark:border-brand-500/30 rounded-xl text-sm font-medium text-brand-700 dark:text-brand-300">
    <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
      <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
    </svg>
    <span>{{ selected.size }} formulario{{ selected.size !== 1 ? 's' : '' }} seleccionado{{ selected.size !== 1 ? 's' : '' }}</span>
    @if (isAdmin) {
      <button [appDisableWithoutPermission]="'forms:delete'" (click)="confirmDeleteSelected()"
        class="ml-auto inline-flex items-center gap-1.5 px-3 py-1 text-xs font-medium bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 text-error-600 dark:text-error-400 rounded-lg hover:border-error-400 transition-colors">
        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
        </svg>
        Eliminar
      </button>
    }
    <button (click)="clearSelection()" [class.ml-auto]="!isAdmin"
      class="inline-flex items-center gap-1 text-xs text-gray-500 hover:text-gray-700 dark:hover:text-gray-300">
      <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
      </svg>
      Limpiar
    </button>
  </div>
}

<!-- Tabla -->
<div class="overflow-hidden rounded-xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">
  <div class="max-w-full overflow-x-auto custom-scrollbar">
    <table class="min-w-full">

      <!-- Encabezado -->
      <thead class="border-b border-gray-100 dark:border-white/[0.05]">
        <tr>
          <th class="w-10 px-4 py-3">
            <input type="checkbox" [checked]="isAllSelected" (change)="toggleAll($event)"
              class="w-4 h-4 cursor-pointer accent-brand-500" />
          </th>
          <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Nombre</th>
          <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Tipo</th>
          <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Estado</th>
          <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Notas internas</th>
          <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Actualizado</th>
          <th class="px-5 py-3 font-medium text-gray-500 text-center text-theme-xs dark:text-gray-400">Acciones</th>
        </tr>
      </thead>

      <!-- Cuerpo -->
      <tbody class="divide-y divide-gray-100 dark:divide-white/[0.05]">

        <!-- Skeleton de carga -->
        @if (loading) {
          @for (i of [1,2,3,4,5]; track i) {
            <tr>
              <td class="px-4 py-3"><div class="w-4 h-4 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div></td>
              <td class="px-4 py-3"><div class="h-4 w-40 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div></td>
              <td class="px-4 py-3"><div class="h-5 w-20 bg-gray-200 dark:bg-gray-700 rounded-full animate-pulse"></div></td>
              <td class="px-4 py-3"><div class="h-5 w-20 bg-gray-200 dark:bg-gray-700 rounded-full animate-pulse"></div></td>
              <td class="px-4 py-3"><div class="h-4 w-32 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div></td>
              <td class="px-4 py-3"><div class="h-4 w-24 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div></td>
              <td class="px-4 py-3"></td>
            </tr>
          }
        } @else {

          @for (form of forms; track form.id) {
            <tr (click)="openDetail.emit(form)" class="cursor-pointer">

              <!-- Checkbox -->
              <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400" (click)="$event.stopPropagation()">
                <input type="checkbox" [checked]="selected.has(form.id)" (change)="toggleRow(form.id, $event)"
                  class="w-4 h-4 cursor-pointer accent-brand-500" />
              </td>

              <!-- Nombre -->
              <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
                <span class="block font-medium text-gray-800 dark:text-white/90">{{ form.name }}</span>
              </td>

              <!-- Tipo -->
              <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
                <app-badge [color]="'info'">{{ form.formType | formTypeLabel }}</app-badge>
              </td>

              <!-- Estado -->
              <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
                <app-badge [color]="form.status | formStatus: 'color'">{{ form.status | formStatus }}</app-badge>
              </td>

              <!-- Notas internas (inc29) -->
              <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400 max-w-[220px]">
                @if (form.internalNotes) {
                  <span class="block truncate text-gray-600 dark:text-gray-300" [title]="form.internalNotes">{{ form.internalNotes }}</span>
                } @else {
                  <span class="text-gray-400 dark:text-gray-500">—</span>
                }
              </td>

              <!-- Actualizado -->
              <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
                @if (form.datetimeUpdated) {
                  {{ form.datetimeUpdated | date: 'd MMM y' }}
                } @else {
                  <span class="text-gray-400 dark:text-gray-500">—</span>
                }
              </td>

              <!-- Acciones -->
              <td class="px-4 py-3 text-gray-500 text-center text-theme-sm dark:text-gray-400" (click)="$event.stopPropagation()">
                <div class="flex items-center justify-center gap-2">

                  <button [appDisableWithoutPermission]="'forms:edit'" (click)="openEditor.emit(form.id)" title="Editar"
                    class="rounded-lg p-2 hover:bg-gray-100 dark:hover:bg-white/[0.05] transition-colors">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
                    </svg>
                  </button>

                  <button [appDisableWithoutPermission]="'forms:create'" (click)="duplicateForm.emit(form.id)" title="Duplicar"
                    class="rounded-lg p-2 hover:bg-gray-100 dark:hover:bg-white/[0.05] transition-colors">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"/>
                    </svg>
                  </button>

                  <button (click)="openSubmissions.emit(form.id)" title="Ver envíos"
                    class="rounded-lg p-2 hover:bg-gray-100 dark:hover:bg-white/[0.05] transition-colors">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 17v-6m4 6V7m4 10v-2M5 21h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2z"/>
                    </svg>
                  </button>

                  @for (act of actionsFor(form.status); track act.action) {
                    <button [appDisableWithoutPermission]="'forms:edit'" (click)="emitAction(form.id, act.action)" [title]="act.label"
                      class="rounded-lg p-2 transition-colors"
                      [class.hover:bg-gray-100]="act.icon !== 'archive'"
                      [class.dark:hover:bg-white/[0.05]]="act.icon !== 'archive'"
                      [class.hover:bg-amber-50]="act.icon === 'archive'"
                      [class.hover:text-amber-600]="act.icon === 'archive'">
                      @switch (act.icon) {
                        @case ('publish') {
                          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
                        }
                        @case ('pause') {
                          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 9v6m4-6v6m7-3a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
                        }
                        @case ('resume') {
                          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"/><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
                        }
                        @case ('archive') {
                          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"/></svg>
                        }
                        @case ('restore') {
                          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/></svg>
                        }
                      }
                    </button>
                  }

                  @if (isAdmin) {
                    <button [appDisableWithoutPermission]="'forms:delete'" (click)="confirmDeleteOne(form.id, $event)" title="Eliminar"
                      class="rounded-lg p-2 hover:bg-error-50 hover:text-error-600 transition-colors">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                      </svg>
                    </button>
                  }

                </div>
              </td>

            </tr>
          } @empty {
            <tr>
              <td colspan="7" class="px-5 py-8 text-center">
                <div class="flex flex-col items-center gap-2 text-gray-500 dark:text-gray-400">
                  <svg class="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1"
                      d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25z"/>
                  </svg>
                  <span>No se encontraron formularios</span>
                </div>
              </td>
            </tr>
          }

        }
      </tbody>
    </table>
  </div>

  <!-- Paginación -->
  @if (totalPages >= 1) {
  <div class="mt-4 border-t border-gray-200 dark:border-gray-700 pt-4 px-5 pb-4">
    <div class="flex items-center justify-between gap-4 flex-wrap">
      <div class="flex items-center gap-2">
        <span class="text-sm text-gray-500 dark:text-gray-400">{{ totalElements }} registros</span>
        <select [ngModel]="pageSize" (ngModelChange)="pageSizeChange.emit($event)"
          class="px-2 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600
                 bg-white dark:bg-gray-800 text-gray-900 dark:text-white
                 focus:ring-2 focus:ring-brand-500 focus:border-transparent">
          @for (opt of pageSizeOptions; track opt) {
            <option [value]="opt">{{ opt }}</option>
          }
        </select>
      </div>
      <div class="flex items-center gap-2">
        <button type="button" (click)="pageChange.emit(currentPage - 1)" [disabled]="!hasPrevPage"
          class="px-3 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600
                 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300
                 hover:bg-gray-50 dark:hover:bg-gray-700
                 disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
          Anterior
        </button>
        <div class="flex items-center gap-1.5">
          <span class="text-sm text-gray-500 dark:text-gray-400">Página</span>
          <select [ngModel]="pageDisplay" (ngModelChange)="pageChange.emit($event - 1)"
            class="px-2 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600
                   bg-white dark:bg-gray-800 text-gray-900 dark:text-white
                   focus:ring-2 focus:ring-brand-500 focus:border-transparent">
            @for (p of pagesArray; track p) {
              <option [value]="p">{{ p }}</option>
            }
          </select>
          <span class="text-sm text-gray-500 dark:text-gray-400">de {{ totalPages }}</span>
        </div>
        <button type="button" (click)="pageChange.emit(currentPage + 1)" [disabled]="!hasNextPage"
          class="px-3 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600
                 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300
                 hover:bg-gray-50 dark:hover:bg-gray-700
                 disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
          Siguiente
        </button>
      </div>
    </div>
  </div>
  }
</div>

<!-- Modal de confirmación de borrado -->
<app-confirmation-modal
  [isOpen]="deleteConfirm.isOpen"
  title="Eliminar formulario{{ deleteConfirm.ids.length > 1 ? 's' : '' }}"
  [message]="'¿Eliminar ' + deleteConfirm.ids.length + ' formulario' + (deleteConfirm.ids.length > 1 ? 's' : '') + '? Esta acción no se puede deshacer.'"
  confirmText="Eliminar"
  variant="danger"
  (confirm)="onDeleteConfirmed()"
  (cancel)="onDeleteCancelled()"
/>
